import React from 'react';
import { motion } from 'framer-motion';
import { useMobilePerformance } from '../../hooks/useMobilePerformance';

/**
 * A wrapper component that handles lazy-loading visual weight 
 * and optimizes animations based on device capability.
 */
const SectionOptimizer = ({ children, className = "", delay = 0 }) => {
  const { yOffset, duration, viewportMargin, isMobile } = useMobilePerformance();

  return (
    <motion.div
      initial={{ opacity: 0, y: yOffset }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: viewportMargin }}
      transition={{ 
        duration: duration, 
        delay: isMobile ? delay * 0.5 : delay, // Faster staggering on mobile
        ease: [0.16, 1, 0.3, 1] 
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default SectionOptimizer;